






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { MailCallbackRequestForUserPrompt } from "@/dto/mail/callback/MailCallback";
import MailCallbackService from "@/services/MailCallbackService";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";

@Component({
  components: {
    PortalCheckbox
  }
})
export default class CreateSubscriptionMailCallback extends Vue {
  @Prop({ required: true }) token!: string;
  @Prop({ required: true }) requestData!: MailCallbackRequestForUserPrompt;

  termsOfServiceAccepted = false;
  privacyPolicyAccepted = false;
  consentForMarketing = false;

  get params() {
    return this.requestData.params || {};
  }

  get validationResults() {
    return this.requestData.validationResults || {};
  }

  get companiesCountIsActual(): boolean {
    return this.validationResults.companiesCountIsActual === true;
  }

  get personProfileIsActual(): boolean {
    if (this.validationResults.personProfileIsActual === undefined) return true;
    return this.validationResults.personProfileIsActual === true;
  }

  get priceIsActual(): boolean {
    return this.validationResults.priceIsActual === true;
  }

  get isAllActual(): boolean {
    return this.companiesCountIsActual && this.priceIsActual && this.personProfileIsActual;
  }

  // Active amounts to be used for display and submission
  get currentCompaniesCount(): number {
    return this.companiesCountIsActual ? this.params.companiesCount : this.validationResults.actualCompaniesCount;
  }

  get currentHasPersonProfile(): boolean {
    return this.personProfileIsActual ? !!this.params.hasPersonProfile : !!this.validationResults.actualHasPersonProfile;
  }

  get hasItemsToSubscribe(): boolean {
    return this.currentCompaniesCount > 0 || this.currentHasPersonProfile;
  }

  get currentSubtotalCents(): number {
    return this.priceIsActual ? this.params.subtotalPrecalc : this.validationResults.actualPriceCents;
  }

  get currentTaxCents(): number {
    return this.priceIsActual ? this.params.taxPrecalc : this.validationResults.actualTaxCents;
  }

  // Formatting helpers
  formatCurrency(cents: number): string {
    return `$${(cents / 100).toFixed(2)}`;
  }

  get localizedPeriodicity(): string {
    const periodicity = this.params.periodicity;
    if (!periodicity) return '';
    return this.$t(`subscriptions.periodicity.short.${periodicity}`).toString().toLowerCase();
  }

  get entitiesText(): string {
    const count = this.currentCompaniesCount;
    const hasPerson = this.currentHasPersonProfile;

    if (hasPerson && count > 0) {
      return this.$t('subscriptions.callback.entities.both', { count }).toString();
    } else if (hasPerson) {
      return this.$t('subscriptions.callback.entities.person_only').toString();
    } else {
      return this.$t('subscriptions.callback.entities.companies_only', { count }).toString();
    }
  }

  get messageOptions() {
    return {
      entities: this.entitiesText,
      price: this.formatCurrency(this.currentSubtotalCents),
      tax: this.formatCurrency(this.currentTaxCents),
      periodicity: this.localizedPeriodicity
    };
  }

  async subscribe() {
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      (this as any).$nts.error(this.$t("auth.policy_acceptance.validation_error") as string);
      return;
    }

    (this as any).$loadOn();

    try {
      const response = await MailCallbackService.runCallbackAction(this.token, {
        params: {
          action: "accept",
          subtotalCents: this.currentSubtotalCents,
          taxCents: this.currentTaxCents,
          termsOfServiceAccepted: this.termsOfServiceAccepted,
          privacyPolicyAccepted: this.privacyPolicyAccepted,
          consentForMarketing: this.consentForMarketing
        }
      });

      const params = response.data.params;
      if (params && params.approveLink) {
        this.$emit('success', params.approveLink);
      } else {
        (this as any).$nts.error("No approval link received from the server.");
      }
    } catch (e: any) {
      console.error("Error subscribing", e);
      (this as any).$nts.error(e.response?.data?.message || "An error occurred while confirming your subscription. Please try again.");
    } finally {
      (this as any).$loadOff();
    }
  }
}
